import io from 'socket.io-client';

import { Config } from '../config';

export const connectToChat = (token, onMessage, onReadMessage) => {
  const socket = io(Config.BASE_URL, {
    transports: ['websocket', 'polling'],
    auth: {
      token: token,
    },
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
    timeout: 20000,
  });

  socket.on('connect', () => {
    console.log('Socket connected');
    socket.emit('subscribeToMessages');
  });

  socket.on('connect_error', error => {
    console.error('Connection error:', error.message);
  });

  socket.on('disconnect', reason => {
    console.log('disconnect:', reason);
    if (reason === 'io server disconnect') {
      // Server disconnected us, reconnect manually
      socket.connect();
    }
    // otherwise socket.io will auto-reconnect
  });

  socket.on('reconnect', attemptNumber => {
    console.log('Socket reconnected, attempt:', attemptNumber);
    socket.emit('subscribeToMessages');
  });

  socket.on('reconnect_error', error => {
    console.error('Reconnect error:', error.message);
  });

  socket.io.on('reconnect_failed', () => {
    console.error('Reconnect failed after all attempts, retrying...');
    socket.connect();
  });

  socket.on('newMessage', msg => {
    // console.log('newMessage', msg);
    if (onMessage) {
      onMessage(msg);
    }
  });

  socket.on('readMessages', msg => {
    console.log('readMessages:', msg);
    if (onReadMessage) {
      onReadMessage(msg);
    }
  });

  return socket;
};
